import React, { createContext, useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import Constants from '../../utils/Constants';
import CommonUtils from '../../utils/CommonsUtils';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import _ from 'lodash';

const ERR_CODE_RESPONSE = 'ERR_BAD_RESPONSE';
const ERR_CODE_REQUEST = 'ERR_BAD_REQUEST';
const ERR_STATUS_500 = 500;
const ERR_STATUS_401 = 401;
const ERR_JWT_MESSAGE = 'JWT';
const defaultUserContext = {};
export const UserContext = createContext(defaultUserContext);

export const UserContextProvider = (props) => {
    const token = sessionStorage.getItem(Constants.LOCAL_STORAGE.AUTHORIZATION) || '';
    const [isAuthenticated, setIsAuthenticated] = useState(token.length > 0);
    const [contextStatus, setContextStatus] = useState(Constants.CONTEXT_STATUS.IDLE);
    const [role, setRole] = useState([]);
    const [userData, setUserData] = useState({});
    const [userLoginContext, setUserLoginContext] = useState({});
    const [companyList, setCompanyList] = useState({});
    const [selectedCompany, setSelectedCompany] = useState({});
    const [invitedUser, setInvitedUser] = useState({});
    const [companyManager, setCompanyManager] = useState(null);
    const [isSwitchCompany, setIsSwitchCompany] = useState(false);
    const [isInit, setIsInit] = useState(false);
    const navigate = useNavigate();
    const { t } = useTranslation();

    const location = useLocation();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        let tokenFromParams = searchParams.get('token');
        // this variable from mycareer web
        const companyId = searchParams.get('connectedCompany');
        if (tokenFromParams && companyId) {
            if (token === '') {
                sessionStorage.setItem(Constants.LOCAL_STORAGE.AUTHORIZATION, tokenFromParams);
                setIsAuthenticated(true);
            }
        } else if (tokenFromParams) {
            sessionStorage.setItem(Constants.LOCAL_STORAGE.AUTHORIZATION, tokenFromParams);
            setIsAuthenticated(true);
        }
    }, [searchParams, setIsAuthenticated]);

    const showConfirmAlert = useCallback(() => {
        CommonUtils.displayDefaultConfirmAlert(navigate, t);
    }, [navigate, t]);

    useEffect(() => {
        if (isAuthenticated) {
            // this variable from mycareer web
            let companyIdFromParams = sessionStorage.getItem(Constants.SESSION_STORAGE.SELECTED_COMPANY_ID);

            // set companyInfo and role of user after switch company
            if (contextStatus === Constants.CONTEXT_STATUS.LOADING_ROLE && companyIdFromParams) {
                const newCompany = companyList.find((item) => item.companyId === companyIdFromParams);
                axios.get(`member_invite/employeeRole?companyId=${companyIdFromParams}`).then((value) => {
                    value.data && setInvitedUser(value.data);
                    setSelectedCompany(newCompany);
                    setContextStatus(Constants.CONTEXT_STATUS.SUCCESS);
                });
            }
        } else {
            // Check authentication and show warning message if go page without token
            let tokenFromParams = searchParams.get('token');
            if (
                !tokenFromParams &&
                contextStatus !== Constants.CONTEXT_STATUS.IS_LOGOUT &&
                location.pathname !== '/' &&
                location.pathname !== '/webLoginCallback' &&
                !location.pathname.includes('signUp')
            ) {
                showConfirmAlert();
            }
        }
    }, [searchParams, contextStatus, isAuthenticated]);

    useEffect(() => {
        if (isAuthenticated) {
            const getUserInfo = async () => {
                try {
                    setContextStatus(Constants.CONTEXT_STATUS.LOADING);
                    const companyId = searchParams.get('connectedCompany') || null;
                    const companyIdFromParams = sessionStorage.getItem(Constants.SESSION_STORAGE.SELECTED_COMPANY_ID);
                    if (!companyIdFromParams && companyId) {
                        sessionStorage.setItem(Constants.SESSION_STORAGE.SELECTED_COMPANY_ID, companyId);
                    }
                    const resultPromise = await axios.get(`getUserFromToken?token=${token.slice(7)}`).catch((err) => {
                        if (
                            (err.code === ERR_CODE_RESPONSE &&
                                err.response.status === ERR_STATUS_500 &&
                                err.response.data.message.includes(ERR_JWT_MESSAGE)) ||
                            (err.code === ERR_CODE_REQUEST && err.response.status === ERR_STATUS_401)
                        ) {
                            // In case of invalid Authorization Code, then removing the code from browser and force navigating to Login Page
                            setContextStatus(Constants.CONTEXT_STATUS.FAILED);
                            sessionStorage.removeItem(Constants.LOCAL_STORAGE.AUTHORIZATION);
                            sessionStorage.removeItem(Constants.SESSION_STORAGE.SELECTED_COMPANY_ID);
                            sessionStorage.removeItem(Constants.LOCAL_STORAGE.LANGUAGE);
                            setIsAuthenticated(false);
                            setRole([]);
                            setUserData({});
                            navigate('/');
                            setInvitedUser({});
                        }
                    });
                    let userInfo = resultPromise.data;
                    setUserData(userInfo.user);
                    setRole(userInfo.role);
                    const companyIds = userInfo.user.companyList?.map((company) => {
                        const result = company.split('-');
                        return result[0];
                    });
                    companyIds.unshift(userInfo.user.companyId);
                    if (companyIds) {
                        axios.get(`company/list?ids=${companyIds}`).then((res) => {
                            // debugger;
                            if (res.data) {
                                // debugger;
                                const companyList = res.data.map((company) => {
                                    return {
                                        companyId: company.id,
                                        companyName: company.name,
                                        serviceType: company.serviceType,
                                        logoUrl: company.logoUrl,
                                        homePage: company.homePage,
                                        phone: company.phone,
                                        region: company.region,
                                        address: company.address,
                                        memo: company.memo,
                                        emailManager: company.emailManager,
                                        nameManager: company.nameManager
                                    };
                                });
                                setCompanyList(companyList.reverse());
                                let manageCompany;
                                // const bCompanyList = companyList.filter((company) => company.companyId !== userInfo.user.companyId);
                                // if (userInfo.user.mainCompanyId) {
                                //     manageCompany = companyList.filter((company) => company.companyId === userInfo.user.mainCompanyId);
                                // }
                                if (typeof manageCompany === 'undefined' || manageCompany.length <= 0) {
                                    manageCompany = companyList.filter(
                                        (company) => company.companyId === userInfo.user.companyId
                                    );
                                    // if (manageCompany[0].isExpired && bCompanyList.length > 0) {
                                    //     axios
                                    //         .patch(`ttok_users/${userData.id}`, {
                                    //             mainCompanyId: bCompanyList[0].companyId
                                    //         })
                                    //         .then((res) => {
                                    //             if (res && res.data) {
                                    //                 setUserData({ ...userData, mainCompanyId: bCompanyList[0].companyId });
                                    //             }
                                    //         });
                                    // }
                                }
                                // !userInfo.role.includes(Constants.ROLE.SUPER_ADMIN) && setSelectedCompany(manageCompany[0].isExpired ? bCompanyList[0] : manageCompany[0]);
                                if (!companyIdFromParams && !companyId) {
                                    !userInfo.role.includes(Constants.ROLE.SUPER_ADMIN) &&
                                        setSelectedCompany(manageCompany[0]);
                                    setCompanyManager(manageCompany[0]);
                                    axios
                                        .get(`member_invite/employeeRole?companyId=${manageCompany[0].companyId}`)
                                        .then((value) => {
                                            value.data && setInvitedUser(value.data);
                                            setContextStatus(Constants.CONTEXT_STATUS.SUCCESS);
                                        });
                                } else {
                                    setContextStatus(Constants.CONTEXT_STATUS.LOADING_ROLE);
                                }
                            }
                        });
                    } else {
                        if (!companyIdFromParams && !companyId) {
                            axios
                                .get(`member_invite/employeeRole?companyId=${userInfo.user.companyId}`)
                                .then((value) => {
                                    value.data && setInvitedUser(value.data);
                                    setContextStatus(Constants.CONTEXT_STATUS.SUCCESS);
                                });
                        } else {
                            setContextStatus(Constants.CONTEXT_STATUS.LOADING_ROLE);
                        }
                    }

                    /*setRole(["SUPER_ADMIN", "VIEWER"]);*/
                } catch (err) {
                    setContextStatus(Constants.CONTEXT_STATUS.FAILED);
                    console.log('Error: ' + err.message);
                }
            };
            getUserInfo();
        }
    }, [isAuthenticated, token]);

    const isSuperAdminRole = () => {
        return role.includes(Constants.ROLE.SUPER_ADMIN);
    };

    const isManagerUser = useCallback(() => {
        if (selectedCompany && userData) {
            return selectedCompany.companyId === userData.companyId;
        }
        return false;
    }, [selectedCompany, userData]);

    const isInvitedHrRole = () => {
        return Object.keys(invitedUser).includes(Constants.ROLE.INVITED_HR);
    };

    const isInvitedJobPostingRole = () => {
        return Object.keys(invitedUser).includes(Constants.ROLE.INVITED_JOB);
    };

    const isInvitedEmployeeListRole = () => {
        return Object.keys(invitedUser).includes(Constants.ROLE.EMPLOYEE_LIST);
    };

    const isInvitedAnnouncementRole = () => {
        return Object.keys(invitedUser).includes(Constants.ROLE.ANNOUNCEMENT);
    };

    const isInvitedWorkManagementRole = () => {
        return Object.keys(invitedUser).includes(Constants.ROLE.WORK_MANAGEMENT);
    };

    const isInvitedLeaveManagementRole = () => {
        return Object.keys(invitedUser).includes(Constants.ROLE.LEAVE_MANAGEMENT);
    };

    const isInvitedGoalManagementRole = () => {
        return Object.keys(invitedUser).includes(Constants.ROLE.GOAL_MANAGEMENT);
    };

    const isInvitedGoalRole = () => {
        return Object.keys(invitedUser).includes(Constants.ROLE.GOAL);
    };

    const isUserRole = () => {
        return role.includes(Constants.ROLE.USER);
    };

    const invitedUserRole = () => {
        return invitedUser;
    };

    const isCorporateCustomerRole = () => {
        return role.includes(Constants.ROLE.CORPORATE_CUSTOMER);
    };

    const permissionHandlePageAuthority = () => {
        return isCorporateCustomerRole() || isSuperAdminRole() || isManagerUser();
    };

    const goToMainPage = () => {
        if (_.isEmpty(invitedUser) && _.isEmpty(selectedCompany)) {
            setIsInit(true);
        }
        if (isSuperAdminRole()) {
            navigate('/company/authority');
            return;
        } else if (isManagerUser()) {
            navigate('/setting/company');
            return;
        } else {
            if (!_.isEmpty(invitedUserRole())) {
                if (isInvitedHrRole()) {
                    navigate('/company/hrCardDetail');
                    return;
                } else if (isInvitedEmployeeListRole()) {
                    navigate('/company/authority');
                    return;
                } else if (isInvitedWorkManagementRole()) {
                    navigate('/company/workManagement');
                    return;
                } else if (isInvitedLeaveManagementRole()) {
                    navigate('/company/leaveManagement');
                    return;
                } else if (isInvitedJobPostingRole()) {
                    navigate('/recruitment/jobPosting');
                    return;
                }
            }
        }
    };
    useEffect(() => {
        isInit && goToMainPage();
    }, [isInit]);

    return (
        <UserContext.Provider
            value={{
                isAuthenticated,
                setIsAuthenticated,
                role,
                setRole,
                userData,
                setUserData,
                userLoginContext,
                setUserLoginContext,
                setInvitedUser,
                invitedUser,
                contextStatus,
                setContextStatus,
                companyList,
                setCompanyList,
                selectedCompany,
                companyManager,
                setSelectedCompany,
                isSwitchCompany,
                setIsSwitchCompany,
                isSuperAdminRole,
                isInvitedJobPostingRole,
                isInvitedEmployeeListRole,
                isInvitedAnnouncementRole,
                isInvitedWorkManagementRole,
                isInvitedLeaveManagementRole,
                isInvitedGoalManagementRole,
                isInvitedGoalRole,
                isInvitedHrRole,
                isUserRole,
                invitedUserRole,
                isCorporateCustomerRole,
                isManagerUser,
                permissionHandlePageAuthority,
                goToMainPage
            }}
        >
            {props.children}
        </UserContext.Provider>
    );
};
